import { render, staticRenderFns } from "./CardsWithSloganMobile.vue?vue&type=template&id=b43c510e"
import script from "./CardsWithSloganMobile.vue?vue&type=script&lang=js"
export * from "./CardsWithSloganMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports